import React, { Component } from 'react';
import { DropdownButton } from 'react-bootstrap';
import { MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { reprocessSelectedMediaItemIfOK, reprocessSelectedDatasetIfOK, reprocessSceneIfOK } from '../../actions';
import { ReprocessingModal } from '../reprocessingModal';

class ReprocessingSegment extends Component {
    render() {
        const { anySelected, reprocessSceneIfOK, reprocessSelectedDatasetIfOK, reprocessSelectedMediaItemIfOK, scene, inScene } = this.props;

        return (
            <div>
                <DropdownButton
                    bsStyle='default'
                    title='Reprocess'
                    key='reprocess-1'
                    id='rep-dropdown-basic-1'
                >
                    <MenuItem eventKey="3" disabled={!anySelected || !inScene} onClick={() => reprocessSelectedMediaItemIfOK(scene)}>
                        <i className="fas fa-check-square"></i>&nbsp; Selected
                    </MenuItem>
                    <MenuItem eventKey="1" disabled={!inScene} onClick={() => reprocessSceneIfOK(scene)}>
                        <i className="fas fa-list-ul"></i>&nbsp; All
                    </MenuItem>
                    <MenuItem eventKey="2" disabled={!inScene} onClick={() => reprocessSelectedDatasetIfOK(scene)}>
                        <i className="fas fa-list-ol"></i>&nbsp; Datasets
                    </MenuItem>
                </DropdownButton>
                <ReprocessingModal key='reprocessingmodal' />
            </div>
            );
    }
}

ReprocessingSegment.propTypes = {
    scene: PropTypes.string,
    inScene: PropTypes.bool.isRequired,
    anySelected: PropTypes.bool.isRequired,
    reprocessSceneIfOK: PropTypes.func.isRequired,
    reprocessSelectedDatasetIfOK: PropTypes.func.isRequired,
    reprocessSelectedMediaItemIfOK: PropTypes.func.isRequired,

};

const mapStateToProps = state => ({
    scene: state.scene.current,
});

const mapDispatchToProps = {
    reprocessSelectedMediaItemIfOK,
    reprocessSelectedDatasetIfOK,
    reprocessSceneIfOK
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReprocessingSegment);



// WEBPACK FOOTER //
// ./src/components/actionBar/ReprocessingSegment.js